<template>
  <div class="container col-md-12">
    <h1>Social Security Taxable Calc</h1>
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>
    <div v-if="calcData">
      <hr />
      <h3>Result</h3>
      <md-content>
        <md-content class="md-padding">
          <table class="table table-striped table-bordered">
            <tr>
              <th>Step</th>
              <th>Item</th>
              <th>LDI Rate A</th>
              <th>LDI Rate B</th>
              <th>LDI Rate C</th>
              <th>LDI Rate D</th>
              <th>LDI Rate E</th>
            </tr>
            <tr>
              <td>1</td>
              <td>Annual Social Security Benefit</td>
              <td>
                {{
                  calcData.ldi_a.annual_benefit | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.annual_benefit | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.annual_benefit | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.annual_benefit | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.annual_benefit | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>2</td>
              <td>50% of line 1</td>
              <td>
                {{
                  calcData.ldi_a.half_annual_benefit
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.half_annual_benefit
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.half_annual_benefit
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.half_annual_benefit
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.half_annual_benefit
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>3</td>
              <td>Income from lines 15b, 16b</td>
            </tr>
            <tr>
              <td>a</td>
              <td>- DC Pre-Tax</td>
              <td>
                {{ calcData.ldi_a.dc_pre_tax | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.dc_pre_tax | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.dc_pre_tax | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.dc_pre_tax | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.dc_pre_tax | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td>b</td>
              <td>- DC Post-Tax Taxable</td>
              <td>
                {{
                  calcData.ldi_a.dc_post_tax_taxable
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.dc_post_tax_taxable
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.dc_post_tax_taxable
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.dc_post_tax_taxable
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.dc_post_tax_taxable
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td>c</td>
              <td>- DC Rollover</td>
              <td>
                {{
                  calcData.ldi_a.dc_rollover | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.dc_rollover | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.dc_rollover | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.dc_rollover | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.dc_rollover | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td>d</td>
              <td>- DC ER Match</td>
              <td>
                {{
                  calcData.ldi_a.dc_er_match | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.dc_er_match | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.dc_er_match | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.dc_er_match | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.dc_er_match | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td>e</td>
              <td>- DC ER Other</td>
              <td>
                {{
                  calcData.ldi_a.dc_er_other | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.dc_er_other | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.dc_er_other | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.dc_er_other | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.dc_er_other | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td>f</td>
              <td>- NQDC</td>
              <td>
                {{ calcData.ldi_a.nqdc | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.nqdc | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.nqdc | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.nqdc | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.nqdc | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td>g</td>
              <td>- NQDC</td>
              <td>
                {{
                  calcData.ldi_a.other_pre_tax | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.other_pre_tax | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.other_pre_tax | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.other_pre_tax | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.other_pre_tax | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td>h</td>
              <td>- Sponsor DB</td>
              <td>
                {{ calcData.ldi_a.sponsor_db | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.sponsor_db | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.sponsor_db | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.sponsor_db | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.sponsor_db | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td>i</td>
              <td>- Other DB</td>
              <td>
                {{ calcData.ldi_a.other_db | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.other_db | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.other_db | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.other_db | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.other_db | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>
                {{
                  calcData.ldi_a.monthly_income_sum
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.monthly_income_sum
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.monthly_income_sum
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.monthly_income_sum
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.monthly_income_sum
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>4</td>
              <td>Tax Exempt Interest</td>
              <td>
                {{
                  calcData.ldi_a.tax_exempt_interest
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.tax_exempt_interest
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.tax_exempt_interest
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.tax_exempt_interest
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.tax_exempt_interest
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>5</td>
              <td>Adoption Benefits</td>
              <td>
                {{
                  calcData.ldi_a.adoption_benefits
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.adoption_benefits
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.adoption_benefits
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.adoption_benefits
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.adoption_benefits
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td>Foreign Earned Income</td>
              <td>
                {{
                  calcData.ldi_a.foreign_earned_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.foreign_earned_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.foreign_earned_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.foreign_earned_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.foreign_earned_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td>Income from American Samoa</td>
              <td>
                {{
                  calcData.ldi_a.american_samoa_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.american_samoa_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.american_samoa_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.american_samoa_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.american_samoa_income
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>
                {{ calcData.ldi_a.income_sum | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.income_sum | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.income_sum | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.income_sum | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.income_sum | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>6</td>
              <td>Combine lines 2, 3, 4 and 5</td>
              <td>
                {{ calcData.ldi_a.line6 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line6 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line6 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line6 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line6 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>7</td>
              <td>Form 1040 Lines 23 through 32</td>
              <td>
                {{ calcData.ldi_a.line7 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line7 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line7 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line7 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line7 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>8</td>
              <td>Subtract line 7 from line 6</td>
              <td>
                {{ calcData.ldi_a.line8 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line8 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line8 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line8 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line8 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>

            <tr>
              <td>9</td>
              <td>Apply Income Limit</td>
              <td>
                {{
                  calcData.ldi_a.apply_income_limit
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.apply_income_limit
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.apply_income_limit
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.apply_income_limit
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.apply_income_limit
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>

            <tr>
              <td>10</td>
              <td>Subtract line 9 from line 8</td>
              <td>
                {{ calcData.ldi_a.line10 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line10 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line10 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line10 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line10 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>

            <tr>
              <td>11</td>
              <td>Standard Deduction</td>
              <td>
                {{
                  calcData.ldi_a.standard_deduction
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.standard_deduction
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.standard_deduction
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.standard_deduction
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.standard_deduction
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>

            <tr>
              <td>12</td>
              <td>Subtract line 11 from line 10</td>
              <td>
                {{ calcData.ldi_a.line12 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line12 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line12 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line12 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line12 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>13</td>
              <td>Enter Smaller of line 10 or line 11</td>
              <td>
                {{ calcData.ldi_a.line13 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line13 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line13 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line13 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line13 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>14</td>
              <td>Enter 50% of line 13</td>
              <td>
                {{
                  calcData.ldi_a.half_line13 | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_b.half_line13 | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_c.half_line13 | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_d.half_line13 | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  calcData.ldi_e.half_line13 | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>15</td>
              <td>Enter smaller of 2 or 14</td>
              <td>
                {{ calcData.ldi_a.line15 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line15 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line15 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line15 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line15 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>16</td>
              <td>Multiply line 12 by 85%</td>
              <td>
                {{ calcData.ldi_a.line16 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line16 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line16 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line16 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line16 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>17</td>
              <td>Add lines 15 and 16</td>
              <td>
                {{ calcData.ldi_a.line17 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line17 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line17 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line17 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line17 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>18</td>
              <td>Multiply line 1 by 85%</td>
              <td>
                {{ calcData.ldi_a.line18 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line18 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line18 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line18 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line18 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>19</td>
              <td>Enter LESSER of line 17 or line 18</td>
              <td>
                {{ calcData.ldi_a.line19 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.line19 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.line19 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.line19 | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.line19 | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td>END</td>
              <td>Taxable Social Security</td>
              <td>
                {{ calcData.ldi_a.result | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_b.result | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_c.result | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_d.result | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ calcData.ldi_e.result | currency({ fractionCount: 0 }) }}
              </td>
            </tr>
          </table>
        </md-content>
      </md-content>
    </div>
  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
import RoeCalcInputFields from "@/components/calculators/InputFields";
import store from "@/store";
import { mapGetters } from "vuex";
import {
  CALC_SOCIAL_SECURITY_TAXABLE,
  CALC_RESET_STATE
} from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
export default {
  data() {
    return {
      calcAction: CALC_SOCIAL_SECURITY_TAXABLE,
      inputCategories: [
        INPUT_TYPES.PARTICIPANT_BALANCE,
        INPUT_TYPES.PARTICIPANT,
        INPUT_TYPES.PLAN_BASIC_DATA,
        INPUT_TYPES.AUTO_ENROLLMENT,
        INPUT_TYPES.AUTO_INCREASE,
        INPUT_TYPES.EMPLOYEE_CONTRIBUTION,
        INPUT_TYPES.EMPLOYEE_MATCH,
        INPUT_TYPES.EMPLOYEE_OTHER,
        INPUT_TYPES.PRE_TAX_CONTRIBUTION,
        INPUT_TYPES.ROTH_CONTRIBUTION,
        INPUT_TYPES.POST_TAX_CONTRIBUTION,
        INPUT_TYPES.NQDC_CONTRIBUTION,
        INPUT_TYPES.COMPLIANCE_LIMIT
      ]
    };
  },
  components: { RoeCalcInputFields },
  computed: {
    ...mapGetters(["calcData"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
